'use client';

import { PropsWithChildren, useState } from 'react';

import HighlightContext from './HighlightContext';

const HighlightProvider = ({
  children,
  content,
}: PropsWithChildren<{ content: string }>) => {
  const [id, setId] = useState<number | undefined>();
  const handleId = (id: number) => setId(id);
  const resetId = () => setId(undefined);

  return (
    <HighlightContext.Provider
      value={{ id, setId: handleId, reset: resetId, content }}
    >
      {children}
    </HighlightContext.Provider>
  );
};

export default HighlightProvider;
